import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import classNames from 'classnames';
import useMatchBreakpoint from '../../common/hooks/use-match-breakpoint';
import breakpoints from '../../common/constants/breakpoints';
import { t } from '../../localization';
import { ANIMATED_ICONS } from './constants';
import AvatarList from '../common/components/avatar-list';
import Rating from '../common/components/rating';
import configStorage from '../../configuration/config-storage';
import { CUSTOMERS_AMOUNT } from '../common/constants/common';
import avatars from '../common/constants/avatars';

const { ActionButton, Heading, Box, BlinkingIcon, IconButton, HorizontalStack, Stack, Paragraph } =
  designSystem;

const DifmPopup = ({ onNext, onClose }) => {
  const isDesktopView = useMatchBreakpoint(breakpoints.MD);
  const classes = classNames('ws-difm-popup', {
    'ws-difm-popup--is-desktop': isDesktopView,
  });

  const { cdnUrl } = configStorage.get();

  const imageSrc = `${cdnUrl}/difm/images/site-preview-a7d2f91c.jpg`;

  const avatarImages = useMemo(
    () => [
      `${cdnUrl}${avatars.AVATAR_3}`,
      `${cdnUrl}${avatars.AVATAR_2}`,
      `${cdnUrl}${avatars.AVATAR_5}`,
    ],
    [cdnUrl]
  );

  const avatarListPaddingProps = {
    paddingTop: 'spacing-3-xs',
    paddingBottom: 'spacing-3-xs',
    paddingLeft: 'spacing-xs',
    paddingRight: 'spacing-xs',
  };

  return (
    <div
      className={classes}
      style={{
        backgroundImage: `url(${cdnUrl}/difm/images/backgound-gradient-popup-3e8b7f4a.png)`,
      }}
    >
      <div className="ws-difm-popup__decoration-wrapper">
        {ANIMATED_ICONS.map(({ key, ...restProps }) => (
          <BlinkingIcon key={key} {...restProps} />
        ))}
      </div>
      <div className="ws-difm-popup__close-btn">
        <IconButton glyph="close" onClick={onClose} transparent size="medium" />
      </div>
      <div className="ws-difm-popup__content">
        <Box
          paddingTop="spacing-s"
          paddingLeft="spacing-m"
          paddingRight="spacing-m"
          {...(!isDesktopView && { paddingBottom: 'spacing-s' })}
          breakpoints={{
            md: {
              paddingTop: 'spacing-m',
              paddingLeft: 'spacing-l',
              paddingRight: 'spacing-l',
            },
          }}
        >
          <Box marginBottom="spacing-3-xs">
            <Heading type="heading-6" appearance="accent" isUppercase>
              {t('Professional services')}
            </Heading>
          </Box>
          <Box
            marginBottom="spacing-xs"
            breakpoints={{
              md: {
                marginBottom: 'spacing-m',
              },
            }}
          >
            <Heading type="heading-3">
              {t('Let us translate your vision into a professional website')}
            </Heading>
          </Box>
          <Box
            marginBottom="spacing-m"
            breakpoints={{
              md: {
                marginBottom: 'spacing-l',
              },
            }}
          >
            <ActionButton
              format="solid"
              appearance="accent"
              label={t('Learn more')}
              onClick={onNext}
            />
          </Box>
          <div className="ws-difm-popup__avatars-wrapper">
            <Box {...(isDesktopView && avatarListPaddingProps)}>
              <HorizontalStack gap="spacing-3-xs" verticalAlign="center">
                <AvatarList images={avatarImages} size={40} shift={20} />
                <Stack>
                  <Rating stars={5} size={16} />

                  <Paragraph size="small" appearance="medium-emphasis">
                    {t('Trusted by {customers}+ customers', {
                      customers: CUSTOMERS_AMOUNT,
                    })}
                  </Paragraph>
                </Stack>
              </HorizontalStack>
            </Box>
          </div>
          <div className="ws-difm-popup__image-wrapper">
            <img alt="" src={imageSrc} />
          </div>
        </Box>
      </div>
    </div>
  );
};

DifmPopup.propTypes = {
  onNext: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DifmPopup;
